<template>
  <div class="container-fluid">
    <div class="row">
      <div v-if="manual_grading_data.length === 0" class="col-sm-12 text-center mt-5">
        <img src="/empty-views/no-manual-grading-exam.svg" alt="No Manual Grading Exam" class="img-fluid mb-3" style="max-width: 300px; height: auto;" />
        <h3 class="text-muted">No Manual Grading Exam Available</h3>
        <b-button variant="secondary" @click="getBackToExam">Get Back</b-button>
      </div>
      <div v-else class="col-sm-12 col-xl-12 dropdown-job-filter">
        <DataTableForManualGrading ref="list" />
      </div>
    </div>
  </div>
</template>

<script>
import DataTableForManualGrading from "./components/DataTableForManualGrading.vue";

export default {
  components: { DataTableForManualGrading },
  data() {
    return {
      user_access_type: "",
      manual_grading_data: [],
    };
  },
  methods: {
    fetchExamWithManualGrading() {
      this.$store.dispatch("exam/getManualGrading").then((res) => {
        let data = res.data;
        this.manual_grading_data = [...data.data];
        this.user_access_type = data.access_type;
      });
    },
    getBackToExam() {
      this.$router.push({ name: "Exam" });
    },
  },
  created() {
    if (this.role_modules.some((item) => item.value == "exam.create")) {
      this.fetchExamWithManualGrading();
    }
  },
};
</script>
